import each from 'lodash/each';
import map from 'lodash/map';

let extractNumber = (e) => {
    if ( typeof e == "number" ) {
        return e;
    }

    let match = e.match(/([0-9.,]+)/);
    if ( match === null ) {
        throw new Error("No numbers matched");
    } else {
        let number = match[0].replace('.', '').replace(',', '.');
        return parseFloat(number);
    }
}


export const schema = {
    ausruestung: { type: "text" },
    begehbar_im: { type: "checkbox", values: {
        7329: "April",
        7330: "Mai",
        7331: "Juni",
        7332: "Juli",
        7333: "August",
        7334: "September",
        7335: "Oktober",
        7336: "November",
    } },
    bemerkungen: { type: "text" },
    dauer: { type: "text" },
    dh_eigene: { type: "select" },
    difficulty: { type: "select" },
    distance: { type: "int" },
    einkehr:  { type: "text" },
    entry_id:  { type: "int" },
    hm_up:  { type: "int" },
    hm_down:  { type: "int" },
    fitness: { type: "select" },
    image: { type: "text" },
    info:  { type: "text" },
    jahreszeit: { type: "select" },
    kategorie: { type: "select" },
    kml: { type: "int" },
    lage:  { type: "select" },
    lawinengefahr: { type: "text" },
    link:  { type: "text" },
    geeignet:  { type: "text" },
    kinderwagen: {
        type: "bool",
        source: (entry) => entry.geeignet.indexOf("Begehung mit Kinderwagen") !== -1,
    },
    max: { type: "int" },
    min: { type: "int" },
    name:  { type: "text" },
    sonnigerweg: { type: "select" },
    status: { type: "select" },
    status_info: { type: "text" },
    time: { type: "int" },
    typ: { type: "text" },
    weg: { type: "text" },
    wertung_alpine_erfahrung: { type: "int", static_map: {
        0: "",
        1: "Keine alpine Erfahrung notwendig",
        2: "Alpine Vorkenntnisse empfehlenswert! (Wetter, Trittsicherheit)",
        3: "Alpine Erfahrung, Grundkenntnisse, Gefahrenstellen",
        4: "Alpine Erfahrung erforderlich! (alpine Gefahren, Wetterkunde)",
        5: "Alpine Erfahrung wird voraus gesetzt! (alpine Gefahren, Wetterkunde, Gefahrenstellen)",
    } },
    wertung_alpine_kondition: { type: "int" },
    wertung_landschaft: { type: "int" },
    wertung_schwindelfreiheit: { type: "int" },
    wertung_technik: { type: "int" },
};


export function fetchData() {
    let loader = null;

    try {
        let cached = JSON.parse(localStorage.getItem("alpininfo-cache2"));
        if ( cached && cached.ttl > (new Date).getTime() ) {
            console.log("Using cached data");
            loader = Promise.resolve(cached.result);
        }
    }
    catch ( e ) {
        console.log("QueryCache failed: " + e);
        // If cache loading breaks, just ignore it
    }

    if ( loader === null ) {
        console.log("Fetching data from server");
        let server = location.hostname === "localhost" ? "http://alpininfo.tramino.dev" : "https://alpininfo.tramino.de";
        server = "https://alpininfo.tramino.de";
        loader = fetch(server + "/api/alpininfo/?force_cors=1").then(r => r.json());
    }

    return loader.then(
        result => {
            try {
                localStorage.setItem("alpininfo-cache2", JSON.stringify({
                    result: result,
                    ttl: (new Date).getTime() + (30 * 1000),
                }));
            }
            catch ( e ) {
                // LocalStorage is a piece of shit
            }


            let each = require('lodash/each');

            let entries = result = result.entries.map((entry, i) => {
    
                let data = {
                    __entry: entry,
                    __text: "",
                    id: entry.entry_id,
                    problems: [],
                };

                each(schema, (definition, key) => {

                    let value = entry[key];

                    /* Virtual field created by client */
                    if ( definition.source ) {
                        value = definition.source(entry);
                        entry[key] = value;
                    }

                    /* Backend does not guarantee that any key exists. Yeeeah */
                    if ( typeof entry[key] === "undefined" ) {
                        if ( definition.type === "checkbox" ) {
                            data[key] = [];
                        } else {
                            data.problems.push(`Datenfeld "${key}" ist leer`);
                        }
                        return;
                    }


                    switch ( definition.type ) {
                        case "text":
                            if ( definition.handler && value ) {
                                try {
                                    value = definition.handler(value);
                                }
                                catch (e) {
                                    data.problems.push(`Nicht verarbeitbar: ${key} = "${value}" (${e})`);
                                }
                            }
                            break;

                        case "select":
                            /* No special handling needed */
                            break;

                        case "checkbox":
                            value = value.split(",").map(e => {
                                if ( e === "" ) return;
                                return definition.values[parseInt(e, 10)];
                            }).filter(e => typeof e !== "undefined");
                            break;

                        case "bool":
                            if ( value === "1" ) value = true;
                            if ( value === "0" ) value = false;
                            break;

                        case "int":
                            if ( value !== "" ) {
                                let next_value = parseInt(value, 10);
                                if ( isNaN(next_value) ) {
                                    data.problems.push(`Ungültige Zahl im Feld ${key}: "${value}"`);
                                } else {
                                    value = next_value;
                                }
                            }
                            break;

                        default:
                            throw new Error(`parseForm: Unknown type ${definition.type}`);
                    }

                    if ( definition.static_map && typeof definition.static_map[value] !== "undefined" ) {
                        data[`${key}_value`] = definition.static_map[value];
                    }

                    data[key] = value;
                    if ( definition.type === "text" ) {
                        try {
                            data["__text"] += " " + value.toLowerCase();
                        }
                        catch ( e ) {
                            console.log(`[Alpininfo] Failed to lowercase text field ${key}, because it not a text`, value);
                        }
                    }
                });

                data.hoehenmeter = data.hm_up;

                return data;
            });

            console.log("Entries: %o", entries);

            return entries;
        },
        error => {
            console.log(error);
        }
    );
}


export function filterResults(entries, filter) {
    console.group("Filter");

    each(filter, (param, key) => {
        console.log("%s: %o (on %s entries)", key, param, entries.length);

        switch ( key ) {
            case 'hoehenmeter':
                /* param = [ min, max ] */
                entries = entries.filter(e => e.min && e.max && e.min >= param[0] && e.max <= param[1]);
                break;

            case 'kinderwagen':
                /* param = bool */
                if ( param ) { // Filter only when true
                    entries = entries.filter(e => e.kinderwagen);
                }
                break;

            case 'distance':
                /* param = [ min, max ] */
                entries = entries.filter(e => e.distance && e.distance >= param[0] && e.distance <= param[1]);
                break;

            case 'time':
                /* param = [ min, max ] */
                entries = entries.filter(e => e.time && e.time >= param[0] && e.time <= param[1]);
                break;

            case 'wertung_alpine_erfahrung':
            case 'wertung_schwindelfreiheit':
            case 'wertung_alpine_kondition':
                entries = entries.filter(e => e[key] && e[key] >= param[0] && e[key] <= param[1]);
                break;

            case 'kategorie':
            case 'status':
            case 'jahreszeit':
            case 'sonnigerweg':
            case 'lage':
                /* param = options array */
                let values = param.filter(e => e.checked && e.value !== "").map(e => e.value);
                if ( values.length > 0 ) {
                    entries = entries.filter(e => e[key] && e[key].value && values.indexOf(e[key].value) !== -1);
                }
                break;

            case 'search':
                let param_lower = param.toLowerCase();
                if ( param_lower.length > 3 ) {
                    entries = entries.filter(e => e.__text.indexOf(param_lower) !== -1);
                }
                break;

            case 'months':
                let selected_ones = param.filter(e => e.checked).map(e => e.value).filter(e => !!e);
                console.log(selected_ones);
                if ( selected_ones.length > 0 ) {
                    entries = entries.filter(e => {
                        if ( e.begehbar_im.length === 0 ) return false;

                        for (var i = 0; i < selected_ones.length; i++) {
                            if ( e.begehbar_im.indexOf(selected_ones[i]) !== -1 ) {
                                return true;
                            }
                        }
                        return false;
                    });
                }
                break;

            default:
                console.warn("Unknown filter: %s", key);
        }
    })

    console.log("Filter results: %s entries", entries.length);

    console.groupEnd();
    return entries;
}


export function createDataList(entries, key) {
    let orderMap = {};
    let valueMap = {};

    entries.forEach(e => {
        if ( typeof e[key] === "undefined" ) return;
        let name = (e[key].name || "").trim();

        /* Filter crap out */
        if ( name.length === 0 || name === "" || name === "undefined" ) {
            return;
        }

        orderMap[name] = parseInt(e[key].order, 10) || 0;
        valueMap[name] = e[key].value;
    });

    let sortList = map(orderMap, (order, name) => {
        return [name, order];
    });
    sortList.sort((a, b) => {
        return a[1] - b[1];
    });

    let options = [
        {name: "Alle", value: "", exclusive: true, checked: true},
    ]

    sortList.forEach(e => {
        options.push({
            name: e[0],
            value: valueMap[e[0]],
            exclusive: false,
            checked: false,
        })
    });

    return options;
}





// WEBPACK FOOTER //
// ./data.js